import { getTranslationFor } from '@/text/translations';
import styles from './WhatIsPFDN.module.css';

export default function WhatIsPFDN() {
  return (
    <section className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title}>{getTranslationFor('home.whatIs.title')}</h2>
        <p className={styles.description}>{getTranslationFor('home.whatIs.description')}</p>

        <ul className={styles.features}>
        <li className={styles.feature}>
          <div className={styles.icon} aria-hidden="true">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
              <path d="M32 8L38 22L52 24L42 34L44 48L32 42L20 48L22 34L12 24L26 22L32 8Z" fill="url(#gradient1)" />
              <defs>
                <linearGradient id="gradient1" x1="12" y1="8" x2="52" y2="48" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#EF5350" />
                  <stop offset="1" stopColor="#EC407A" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <h3 className={styles.featureTitle}>{getTranslationFor('home.whatIs.feature1.title')}</h3>
          <p className={styles.featureDescription}>{getTranslationFor('home.whatIs.feature1.description')}</p>
        </li>

        <li className={styles.feature}>
          <div className={styles.icon} aria-hidden="true">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
              <rect x="16" y="12" width="32" height="40" rx="2" fill="url(#gradient2)" />
              <path d="M24 24L28 28L24 32M32 28H40" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <defs>
                <linearGradient id="gradient2" x1="16" y1="12" x2="48" y2="52" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#7E57C2" />
                  <stop offset="1" stopColor="#5C6BC0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <h3 className={styles.featureTitle}>{getTranslationFor('home.whatIs.feature2.title')}</h3>
          <p className={styles.featureDescription}>{getTranslationFor('home.whatIs.feature2.description')}</p>
        </li>

        <li className={styles.feature}>
          <div className={styles.icon} aria-hidden="true">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
              <path d="M32 16L42 28H38V40H26V28H22L32 16Z" fill="url(#gradient3)" />
              <rect x="18" y="44" width="28" height="4" rx="2" fill="url(#gradient3)" />
              <defs>
                <linearGradient id="gradient3" x1="18" y1="16" x2="46" y2="48" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#42A5F5" />
                  <stop offset="1" stopColor="#EF5350" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <h3 className={styles.featureTitle}>{getTranslationFor('home.whatIs.feature3.title')}</h3>
          <p className={styles.featureDescription}>{getTranslationFor('home.whatIs.feature3.description')}</p>
        </li>
      </ul>
      </div>
    </section>
  );
}
